import { useEffect, useState } from "react";
import axiosInstance from "services/axiosInstance";
import * as S from "./style";
//Icons
import { Info, FlagBanner } from "@phosphor-icons/react";
//hooks
import useLoading from "../../../../hooks/useLoading";
import { useMultipleModal } from "../../../../hooks/useMultipleModal";
//components
import DetailsCustom from "../../Customer/Details";
import Loading from "../../../Loading";
import LayoutDetails from "../../../LayoutModal/LayoutDetails";
//utils
import { CurrencyFormat } from "utils/CurrencyFormat";
import FormatarData from "utils/FormatData";
//Interface
import { ICancel } from "Interfaces/ICancel";

interface IDetails {
  isOpenModalDetails: boolean;
  setModalClose: () => void;
  selectedUrlId: number | null;
}

export default function Details({
  isOpenModalDetails,
  setModalClose,
  selectedUrlId,
}: IDetails) {
  const [data, setData] = useState<ICancel | null>(null);
  const { isLoading, startLoading, stopLoading } = useLoading();
  const { isOpenModal, toggleModalVisibility } = useMultipleModal();

  const fetchData = async () => {
    startLoading();
    try {
      const response = await axiosInstance.get(`cancellation/${selectedUrlId}`);
      setData(response.data);
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (isOpenModalDetails && selectedUrlId !== null) {
      fetchData();
    }
  }, [isOpenModalDetails, selectedUrlId]);

  if (isOpenModalDetails) {
    return (
      <LayoutDetails
        title="Detalhes do Cancelamento"
        subTitle="Veja todos os detalhes disponíveis sobre o cancelamento."
        setModalClose={setModalClose}
      >
        {isLoading || !data ? (
          <Loading />
        ) : (
          <S.Content>
            <S.Header>
              <S.ContentInfor>
                <S.Infor>
                  <p>N° da Venda:</p>
                  <span>#{data.sale?.number_ata || "-"}</span>
                </S.Infor>
                <S.Infor>
                  <p>Data da venda:</p>
                  <span>{FormatarData(data.sale?.date_sale, 'default') || "-"}</span>
                </S.Infor>
                <S.Infor>
                  <p>Preço:</p>
                  <span>
                    {CurrencyFormat(parseFloat(data.sale?.total_amount || "0"))}
                  </span>
                </S.Infor>
                <S.Infor>
                  <p>Vendedor:</p>
                  <span>
                    {data.user?.first_name || "-"}
                  </span>
                </S.Infor>
              </S.ContentInfor>
            </S.Header>

            <S.Body>
              {/* Cliente */}
              <S.Section>
                <S.ContentBody>
                  <S.InforBody>
                    <p>
                      Cliente
                      {data.sale?.customer && (
                        <S.Button>
                          <Info
                            size={16}
                            onClick={() => toggleModalVisibility("details")}
                          />
                        </S.Button>
                      )}
                    </p>
                    <span className={data.sale?.customer?.flag || ""}>
                      <FlagBanner size={16} weight="fill" />
                      {data.sale?.customer?.full_name || "-"}
                    </span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>Contato</p>
                    <span>{data.sale?.customer?.phone_primary || "-"}</span>
                  </S.InforBody>
                </S.ContentBody>

                <S.ContentBody>
                  <S.InforBody>
                    <p>CPF</p>
                    <span>{data.sale?.customer?.cpf || "-"}</span>
                  </S.InforBody>
                </S.ContentBody>
              </S.Section>
              {/* Fim Cliente */}

              <S.FeaturedSection>
                <S.InforBody>
                  <p>Motivo do Cancelamento</p>
                  <span>{data.reason || '-'}</span>
                </S.InforBody>
              </S.FeaturedSection>

              <S.Section>
                <S.InforBody>
                  <p>Observações adicionais</p>
                  <span>{data.observation || '-'}</span>
                </S.InforBody>
              </S.Section>
            </S.Body>

            <DetailsCustom
              isOpenModalDetails={isOpenModal("details")}
              setModalClose={() => toggleModalVisibility("details")}
              selectedUrlId={data.sale?.customer.id}
            />
          </S.Content>
        )}
      </LayoutDetails>
    );
  }
  return null;
}
